import { Tower } from "../entities/Tower";
import { StageConfig } from "../data/StageConfig";

export class TowerSystem {
  private tower: Tower;

  constructor(tower: Tower) {
    this.tower = tower;
  }

  /** Build a new tower */
  buildTower(): void {
    this.tower.build(StageConfig.blockCount);
  }

  /** Get the current tilt of the tower */
  getTilt(): number {
    return this.tower.calculateTilt();
  }

  /** Check if tower tilt exceeds threshold */
  isTiltExceeded(): boolean {
    return this.getTilt() > StageConfig.tiltThreshold;
  }

  /** Get the number of remaining active blocks */
  getRemainingCount(): number {
    return this.tower.getActiveBlocks().length;
  }

  /** Update tower visuals */
  update(): void {
    this.tower.update();
  }
}
